import { render, staticRenderFns } from "./creatComment.vue?vue&type=template&id=10421c4a&scoped=true"
import script from "./creatComment.vue?vue&type=script&lang=js"
export * from "./creatComment.vue?vue&type=script&lang=js"
import style0 from "./creatComment.vue?vue&type=style&index=0&id=10421c4a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10421c4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10421c4a')) {
      api.createRecord('10421c4a', component.options)
    } else {
      api.reload('10421c4a', component.options)
    }
    module.hot.accept("./creatComment.vue?vue&type=template&id=10421c4a&scoped=true", function () {
      api.rerender('10421c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/comment/creatComment.vue"
export default component.exports